import useAddress from '@/containers/SubscriptionFormPageNew/Components/Address/useAddress'
import { FormControl } from 'baseui/form-control'
import getError from '@/containers/SubscriptionFormPageNew/getError'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'

const Surface = () => {
  const { t, updateAddress, errors, surface } = useAddress()

  return (
    <FormControl error={getError('surface', errors)}>
      <SDInput
        label={t('subscriptionTools:estimator.surface.label')}
        onBlur={surface => updateAddress({ surface })}
        currentValue={surface}
        endEnhancer='m2'
      />
    </FormControl>
  )
}

export default Surface
